// extracted by mini-css-extract-plugin
var _1 = "FavoriteIcon-module__active--rv_JM";
var _2 = "FavoriteIcon-module__icon--xoIny";
export { _1 as "active", _2 as "icon" }
